import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-white px-6 py-28 md:px-12 md:py-40"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-16 flex flex-col justify-between gap-6 md:mb-24 md:flex-row md:items-end">
          <Reveal>
            <p className="mb-6 text-[0.7rem] uppercase tracking-[0.3em] text-sage">
              What we offer
            </p>
            <h2 className="font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl md:text-6xl">
              Treatments, shaped
              <br />
              <span className="italic text-forest">around you</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-base font-light leading-relaxed text-stone">
              We offer focused individual treatments, each targeting a specific need,
              alongside combined packages that weave several therapies together — tailored
              to suit everyone. Whatever you're carrying, there's a path here shaped around
              your body and your wellbeing.
            </p>
          </Reveal>
        </div>

        <div className="grid gap-x-6 gap-y-14 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08}>
              <motion.div
                data-testid={`service-card-${s.id}`}
                whileHover="hover"
                className="group cursor-default"
              >
                <div
                  className={`relative overflow-hidden arch ${
                    s.contain ? "flex h-[360px] items-center justify-center bg-cream" : ""
                  }`}
                >
                  <motion.img
                    src={s.image}
                    alt={s.name}
                    variants={{ hover: { scale: 1.06 } }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className={
                      s.contain
                        ? "aspect-square w-[80%] rounded-full object-cover"
                        : "h-[360px] w-full object-cover"
                    }
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-forest/40 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                </div>
                <div className="mt-6 flex items-start justify-between gap-3">
                  <h3 className="font-serif text-xl leading-snug tracking-tight text-forest">
                    {s.name}
                  </h3>
                  <ArrowUpRight
                    size={20}
                    className="mt-1 shrink-0 text-sage transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-forest"
                  />
                </div>
                <p className="mt-3 text-sm font-light leading-relaxed text-stone">
                  {s.copy}
                </p>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
